import { render, staticRenderFns } from "./algorithmManagement.vue?vue&type=template&id=613747e6&scoped=true"
import script from "./algorithmManagement.vue?vue&type=script&lang=js"
export * from "./algorithmManagement.vue?vue&type=script&lang=js"
import style0 from "./algorithmManagement.vue?vue&type=style&index=0&id=613747e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613747e6",
  null
  
)

export default component.exports